export default __webpack_public_path__ + "static/media/bonus.ab45174a.svg";